import React, { useState } from 'react';
import { Container, Form, Button, Row, Col } from 'react-bootstrap';
import axios from 'axios';
import { API_ENDPOINTS } from '../config';

const AddBlogPage = () => {
  const [formData, setFormData] = useState({
    title: '',
    description: '',
    image: null,
    blogType: ''  // New field for blogType
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  const handleImageChange = (e) => {
    setFormData({ ...formData, image: e.target.files[0] });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      const formDataUpload = new FormData();
      formDataUpload.append('title', formData.title);
      formDataUpload.append('description', formData.description);
      formDataUpload.append('blogType', formData.blogType);
      formDataUpload.append('image', formData.image);

      const response = await axios.post(API_ENDPOINTS.createBlog, formDataUpload, {
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      });
      console.log('Blog created successfully:', response.data);
      // Reset form after successful submission (optional)
      setFormData({
        title: '',
        description: '',
        image: null,
        blogType: ''
      });
    } catch (error) {
      console.error('Error creating blog:', error);
      // Handle error state or display error message to user
    }
  };

  return (
    <Container>
      <Row className="justify-content-md-center mt-4">
        <Col xs={10} md={8} lg={6}>
          <h2 className="text-center mb-4">Add New Blog</h2>
          <Form onSubmit={handleSubmit}>
            <Form.Group controlId="blogTitle">
              <Form.Label>Blog Title</Form.Label>
              <Form.Control
                type="text"
                placeholder="Enter blog title"
                name="title"
                value={formData.title}
                onChange={handleChange}
                required
              />
            </Form.Group>

            <Form.Group controlId="blogDescription">
              <Form.Label>Description</Form.Label>
              <Form.Control
                as="textarea"
                rows={3}
                placeholder="Enter blog description"
                name="description"
                value={formData.description}
                onChange={handleChange}
                required
              />
            </Form.Group>

            <Form.Group controlId="blogType">
              <Form.Label>Blog Type</Form.Label>
              <Form.Control
                type="text"
                placeholder="Enter blog type"
                name="blogType"
                value={formData.blogType}
                onChange={handleChange}
                required
              />
            </Form.Group>

            <Form.Group controlId="blogImage">
              <Form.Label>Blog Image</Form.Label>
              <Form.Control
                type="file"
                name="image"
                onChange={handleImageChange}
                required
              />
            </Form.Group>

            <Button variant="primary" type="submit" className="mt-3">
              Add Blog
            </Button>
          </Form>
        </Col>
      </Row>
    </Container>
  );
};

export default AddBlogPage;
